import { render, staticRenderFns } from "./AnswerTypeLinearScaleMobile.vue?vue&type=template&id=61301a6c&scoped=true"
import script from "./AnswerTypeLinearScaleMobile.vue?vue&type=script&lang=js"
export * from "./AnswerTypeLinearScaleMobile.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeLinearScaleMobile.vue?vue&type=style&index=0&id=61301a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61301a6c",
  null
  
)

export default component.exports